import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import {
  DatePickerProps,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers/DatePicker';
import {
  BaseSingleInputFieldProps,
  DateValidationError,
  FieldSection,
} from '@mui/x-date-pickers/models';
import { useState } from 'react';

import { Icon } from './Icon';
import { IconButton } from './IconButton';

interface ButtonFieldProps
  extends UseDateFieldProps<Date, false>,
    BaseSingleInputFieldProps<
      Date | null,
      Date,
      FieldSection,
      false,
      DateValidationError
    > {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

function ButtonField(props: ButtonFieldProps) {
  const {
    setOpen,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <IconButton
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <Icon icon={icon({ name: 'calendar-day', style: 'regular' })} />
    </IconButton>
  );
}
export const IconDatePicker: React.FC<DatePickerProps<Date>> = (
  props: Omit<DatePickerProps<Date>, 'open' | 'onOpen' | 'onClose'>
) => {
  const [open, setOpen] = useState(false);

  return (
    <MuiDatePicker
      slots={{ field: ButtonField, ...props.slots }}
      slotProps={{ field: { setOpen } as any }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
};
